import AssetDevice from "./AssetDevice";

export default AssetDevice;